module.exports = __webpack_public_path__ + "static/media/cz.b325cced.svg";